/**
 * LiveFlight UI Module
 * Handles loading states, search triggers, and UI flow control
 */

/**
 * UI state properties
 */
export const state = {
  loading: false,

  // Search flow control (redirect-then-search pattern)
  trigger_search: false,
  search_request: {},

  // travelerId -> age declared in the occupancy at search submission, or null
  // for pax the occupancy carries no age for (adults). Frozen on purpose: the
  // booking engine stays editable on /results, but a birth-date range has to
  // reflect the ages the displayed offer was actually priced with.
  committed_traveler_ages: {},
};

/**
 * Freeze the submitted occupancy ages into a plain travelerId -> age map.
 * Every traveler id gets a key, so consumers never have to tell "id missing"
 * apart from "no age declared" - null is the single "fall back to the type
 * label" marker.
 *
 * @param {Array} travelers search_request.travelers
 * @returns {{[travelerId: string]: number|null}}
 */
export const index_traveler_ages = (travelers) =>
  (Array.isArray(travelers) ? travelers : []).reduce((ages, traveler) => {
    const { id, age } = traveler || {};
    ages[String(id)] = typeof age === 'number' && isFinite(age) ? age : null;
    return ages;
  }, {});

/**
 * Custom mutations for UI state
 */
export const mutations = {
  set_loading(state, loading) {
    state.loading = loading;
  },

  // Atomic mutation: ends the search flow in a single commit.
  // Prevents 2 separate subscribe handler calls (localStorage writes).
  end_search(state) {
    state.loading = false;
    state.trigger_search = false;
  },
};

/**
 * Keys to persist in local storage
 */
export const localStorageKeys = ['search_request', 'committed_traveler_ages'];
